/**
 * Save a Blob to the user's machine under `filename`.
 *
 * Needed because these downloads come from authenticated REST calls, so there is no URL to put in an
 * anchor's href at render time: the bytes arrive first and the anchor is synthesised around them.
 *
 * Two details that are easy to get wrong and are the reason this is shared rather than inlined:
 *
 * - The anchor must be in the document before `click()`. Firefox has historically ignored clicks on
 *   detached anchors, so a detached one silently downloads nothing there.
 * - Revoking immediately after `click()` is safe. `click()` runs the activation behaviour
 *   synchronously, which starts the fetch of the blob URL, and revoking a blob URL does not
 *   terminate a fetch already under way. Skipping the revoke pins the blob for the lifetime of the
 *   document, which adds up fast on a list of multi-megabyte reports.
 *
 * Same sequence as AgentUsageHistory/HistoryPage.vue's CSV export, which is the call site this was
 * modelled on.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = filename;

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
